import { postApi, getApi, putApi, patchApi } from "./Api";
import axios from "axios";

const url = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : "http://localhost:3000";

const addConfig = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});
export const getAllDashboardData = (config) => {
  return getApi("/SADashboard/get-data", addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCampaignList = (payload) => {
  let { page, limit, status } = payload;
  return getApi(
    `/SADashboard/campaign-listings/${status}?page=${page}&limit=${limit}`,
    addConfig()
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCampaignByID = (payload) => {
  return postApi("/SADashboard/get-campaign-data", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const approveCampaign = (payload) => {
  return putApi("/SADashboard/approve-campaign", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const deleteCampaign = (payload) => {
  return putApi("/SADashboard/delete-campaign", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const stopCampaign = (payload) => {
  return putApi("/SADashboard/stop-campaign", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAllCategoryData = (payload) => {
  return getApi("/configuration/get-category", addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getUserList = (payload) => {
  let { page, limit, body } = payload;
  return postApi(
    `/SADashboard/get-users-list?page=${page}&limit=${limit}`,
    body,
    addConfig()
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getSourceList = (payload) => {
  let { page, limit, body } = payload;
  return postApi(
    `/SADashboard/get-source-list?page=${page}&limit=${limit}`,
    body,
    addConfig()
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateCampaignDetails = (payload) => {
  return patchApi("/SADashboard/update-campaign-details", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateCompanyDetails = (payload) => {
  return putApi("/SADashboard/update-company-details", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateNotes = (payload) => {
  return putApi("/SADashboard/update-notes", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateContactDetails = (payload) => {
  return patchApi("/configuration/update-contact-details", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateResourceDetails = (payload) => {
  return patchApi("/configuration/update-resource", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateResourceLocationDetails = (payload) => {
  return patchApi("/configuration/update-resource-location", payload, addConfig())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getAllCharityData = () => {
  return getApi(
    "/configuration/get-all-resources?resourceName=Charity",
    addConfig()
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getSuperAdminPledges = (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.status && filters.status !== "ALL") {
    params.append("status", filters.status);
  }
  if (filters.frequency && filters.frequency !== "ALL") {
    params.append("frequency", filters.frequency);
  }
  if (filters.donorName) {
    params.append("donorName", filters.donorName.trim());
  }
  if (filters.startDate) {
    params.append("startDate", filters.startDate);
  }
  if (filters.endDate) {
    params.append("endDate", filters.endDate);
  }

  const query = params.toString();

  return getApi(`/SADashboard/pledges${query ? `?${query}` : ""}`, addConfig())
    .then((data) => data)
    .catch((err) => {
      throw err;
    });
};

export const getSuperAdminPledgeDetails = (pledgeId) => {
  return getApi(`/SADashboard/pledges/${pledgeId}`, addConfig())
    .then((data) => data)
    .catch((err) => {
      throw err;
    });
};

export const distributePledgeFunds = (payload) => {
  return postApi("/SADashboard/pledge-distribution", payload, addConfig())
    .then((data) => data)
    .catch((err) => {
      throw err;
    });
};

export const updatePledgeStatus = ({ pledgeId, status, nextChargeDate, notes }) => {
  const body = {};
  if (status !== undefined) body.status = status;
  if (nextChargeDate) body.nextChargeDate = nextChargeDate;
  if (notes !== undefined) body.notes = notes;

  return patchApi(`/SADashboard/pledges/${pledgeId}`, body, addConfig())
    .then((data) => data)
    .catch((err) => {
      throw err;
    });
};

export const uploadFile = (file, folderName) => {
  const formData = new FormData();
  formData.append("file", file);

  console.log("formData", formData);

  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  };

  return postApi(`/campaign/upload/${folderName}`, formData, config)
    .then((data) => {
      return data.location;
    })
    .catch((err) => {
      throw err;
    });
};

export const deleteFile = (imageUrl, folderName) => {
  const fileName = imageUrl.split("/").pop();
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
    .delete(`${url}/campaign/delete/${folderName}/${fileName}`, config)
    .then((res) => res.data)
    .catch((error) => {
      throw error;
    });
};
